import QRCode from "react-qr-code"
import { Col, Row } from "../Assets/style"
import { useLocation, useParams, useNavigate } from "react-router-dom"
import { verifyPath } from "../../module/routes/path"
import { Container } from "./style"
import { ReactComponent as SuccessIcon } from '../../assets/success_icon.svg'
import { SubtitleMedium } from "../../shared/typography"
import Button from "../../components/Button"
import link_small from "../../assets/icons/link_small.svg";
import { useState } from "react"

export const SignatureVerificationSection = ({ assetWallet, selectedProxyTokenInitMint, isVerified }: { assetWallet: string; selectedProxyTokenInitMint: any; isVerified: boolean }) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const { assetContractAddress } = useParams();
    const [isCopying, setIsCopying] = useState(false)

    const getLink = () => {
        const pathArr = pathname?.split('/')
        pathArr.splice(0, 2)
        return window?.location?.origin + verifyPath + '/' + pathArr?.join('/') + `/${selectedProxyTokenInitMint?.proxy_token_id}`
    }

    return (
        <Container>
            {
                isVerified
                    ? <>
                        <Col align="center">
                            <SuccessIcon />
                            <SubtitleMedium>Signature Verified</SubtitleMedium>
                        </Col>
                    </>
                    : <Col gap="25px">
                        <SubtitleMedium textAlign="center">Verify Your Identity</SubtitleMedium>
                        <Col gap="75px">
                            <Row justify="center">
                                <QRCode
                                    style={{ height: "auto", maxWidth: "200px", width: "200px" }}
                                    value={`value`}
                                />
                            </Row>
                            <Row justify="center">
                                <Button
                                    onClick={() => {
                                        navigator.clipboard.writeText(getLink());
                                        setIsCopying(true);
                                        setTimeout(() => {
                                            setIsCopying(false);
                                        }, 600);
                                    }}
                                    isDisabled={isCopying}
                                    type="BLACK"
                                >
                                    {isCopying ? 'Copied' : 'Copy Link'}
                                </Button>
                                <a href={getLink()} target="blank">
                                    <Button
                                        onClick={() => { }}
                                        IconHeight='15px'
                                        type="OUTLINE"
                                        iconSrc={link_small}
                                    >
                                        Open Link
                                    </Button>
                                </a>
                            </Row>
                        </Col>
                    </Col>
            }
        </Container>
    )
}
//     <CustomTextbar
// config={{
//     title: 'Link',
//     value: `/${shortenAddress(assetWallet)}/${shortenAddress(assetContractAddress || '')}`
// }}
// link={getLink()}
// />